function showToast(msg) {
  const toastDOMText = '<div class="toast">' +
    '<div class="content">' + (msg || '') + '</div>' +
  '</div>';
  $('body').append(toastDOMText);
  setTimeout(hiddenToast, 1000);
}

function hiddenToast() {
  $('body .toast').remove();
}

module.exports = {
  showToast
};
